export default "<canvas id=\"seller-revenue-chart\"></canvas>\n"